
/** Set of tag names that exist only in SVG and never in HTML. Used by the JSX factory to auto-select the SVG namespace. */
export const svgOnlyTags: Set<string> = /*#__PURE__*/ new Set([
    // "a",
    "animate",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "metadata",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    // "script",
    "set",
    "stop",
    // "style",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    // "title",
    "tref",
    "tspan",
    "use",
    "view"
]);

/** RegExp matching SVG attribute names that are not presentation attributes (i.e. are set via `setAttribute` rather than `style`). */
export const nonPresentationSVGAttributes: RegExp =
    /^(a(ll|t|u)|base[FP]|c(al|lipPathU|on)|di|ed|ex|filter[RU]|g(lyphR|r)|ke|l(en|im)|ma(rker[HUW]|s)|n|pat|pr|point[^e]|re[^n]|s[puy]|st[^or]|ta|textL|vi|xC|y|z)/

/** The SVG namespace URI (`http://www.w3.org/2000/svg`). */
export const SVGNamespace = "http://www.w3.org/2000/svg"
